module.exports = __webpack_public_path__ + "img/logo-white.16222193.svg";